import LoginManager from '@core/LoginManager'
import { HttpAuthorizationException, InvalidAccountAuthorityException } from './Exceptions'
import { getLoginPageUrl } from '@/BuildConfig'

const loginManager = LoginManager.getInstance()
const exceptionHandlers = [handleInvalidAccountAuthorityException, handleHttpAuthorizationException]

function handleInvalidAccountAuthorityException<T extends Error>(error: T) {
  if (error instanceof InvalidAccountAuthorityException) {
    console.error(error)
    loginManager.logout(getLoginPageUrl())

    return true
  }

  return false
}

function handleHttpAuthorizationException<T extends Error>(error: T) {
  if (error instanceof HttpAuthorizationException) {
    console.error(error)

    location.replace(getLoginPageUrl())

    return true
  }

  return false
}

function handleException<T extends Error>(error?: T) {
  if (!error) return true

  for (const handler of exceptionHandlers) {
    if (handler(error)) return true
  }

  return true
}

// 全局脚步报错
window.onerror = (message, url, line, column, error) => {
  console.log('onerror handler logging error', message, url, line, column, error)

  handleException(error)
}

// 全局未处理的异步reject
window.onunhandledrejection = (errorEvent) => {
  console.log('onunhandledrejection handler logging error', errorEvent)

  handleException(errorEvent.reason)
}

export {}
